import { render, staticRenderFns } from "./NewsDialog.vue?vue&type=template&id=1b5be3dc"
import script from "./NewsDialog.vue?vue&type=script&lang=js"
export * from "./NewsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5be3dc')) {
      api.createRecord('1b5be3dc', component.options)
    } else {
      api.reload('1b5be3dc', component.options)
    }
    module.hot.accept("./NewsDialog.vue?vue&type=template&id=1b5be3dc", function () {
      api.rerender('1b5be3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/NewsDialog.vue"
export default component.exports